module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("A Glossary of Terms – Essential Pre-Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aircraft/Aeroplane")]), _vm._v(" – Never plane!")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Boss")]), _vm._v(" – Squadron commander (Sqn Cdr); normally of wing commander (Wg Cdr) rank, but occasionally squadron leader (Sqn Ldr) of training units.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Station Commander")]), _vm._v(" (Stn Cdr); usually a group captain (Gp Capt). Less courteous titles are occasionally used. Commands the entire station, with Wg Cdrs immediate subordinates.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CO")]), _vm._v(" – Commanding officer; an officer of any rank who is designated as a unit commander.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Break")]), _vm._v(" – A run in and break is a manoeuvre used by tactical crews to get an aircraft rapidly on the ground. The airfield is approached at high speed, typically 400 knots; over the top of the runway, the aircraft is turned with 3–4 G, with airbrakes out and throttle closed, culminating in arriving at the downwind leg to land with gear and flaps going down. A real fighter pilot does this with sufficient panache to remain unsure of a safe outcome until he flares the aircraft to land.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Weenies")]), _vm._v(" – Anyone other than fighter aircrew.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bomber Pukes")]), _vm._v(" – Bomber aircrew; also known as Mud Movers.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Truckie")]), _vm._v(" – Transport aircraft aircrew.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stall")]), _vm._v(" – Encountered when speed is too low to sustain lift, resulting in loss of control. Can be recovered in less advanced aircraft by easing stick forward and increasing power.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spin")]), _vm._v(" – A stall in which one wing produces more lift than the other, resulting in a rotation towards the ‘more stalled’ wing. Usually bad news in swept wing aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Met Man")]), _vm._v(" – Meteorological Forecaster; synonymous with/related to Sorcerer, Alchemist and Fortune Teller. Has all necessary modern equipment: Radar, Laser, Satellites, Computers, Seaweed and Pine Cones. A coin usually kept handy in case an immediate decision needed.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QFE/QNH/QTE")]), _vm._v(" etc – Aircrew set a pressure value on their altimeters according to their stage of flight. When taking off or landing, a pressure setting is used which gives zero on the altimeter – QFE; once airborne, the height above sea-level is more important, especially when operating in high ground; QNH is then set. When flying at high level, especially in airways or under radar control, all aircraft need to be on a standard pressure setting; this is QTE, and by convention is 1013 millibars or equivalent. Not to be confused with:")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QFI/QWI")]), _vm._v(" – Qualified Flying Instructor (QFI), who is responsible for ‘pure’ flying skills, such as handling, turning, circuits and landings, stalling and spinning etc. Usually a person who smokes a pipe and wears carpet slippers at home. A Qualified Weapons Instructor (QWI) teaches applied flying, i.e. how to turn an aeroplane into a weapon for war: air gunnery, air combat, bombing etc., c.f. Top Gun, Tom Cruise, Ray Ban Sunglasses and, historically, Brylcreem.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IRE")]), _vm._v(" – Instrument Rating Examiner; responsible as the name suggests for maintaining high skills in instrument flying, including instrument approaches. Conducts the annual IRT (Instrument Rating Test) on all squadron pilots, including the Boss. Can be used by some to guarantee a few free beers annually. Boss rarely failed.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("G-Force")]), _vm._v(" – The force to which aircrew are subjected in manoeuvre. We normally live at 1-G. Go over a hill rapidly in your car and you get a bit of negative G-Force. On a fairground machine, you might experience 2-G. Fighter aircrew operate up to 9-G, which can be alleviated by bearing down and grunting (requiring understanding spouse when the underwear arrives in the laundry basket), special suits and physiological training, all to avoid ‘blacking out’ as G exceeds 5.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Control Column")]), _vm._v(" – Also called ‘joystick’ or just ‘stick’.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gear")]), _vm._v(" – Aircraft undercarriage, which on advanced aircraft is selectable up or down. This should be in the order ‘Up’ after take off, and ‘Down’ before landing. But just occasionally …")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Flaps")]), _vm._v(" – High lift surfaces towards the back of the wing, deployed at lower speeds to reduce stalling speed, especially for take off and landing. Similar devices at the front of the wing are called leading edge flaps or slats.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FNG")]), _vm._v(" – F***ing New Guy. Used especially by the Red Arrows Aerobatic Team; has American origins.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Knots")]), _vm._v(" – Measure of speed used in aviation and sailing; means (air) nautical miles per hour. This is slightly higher than statute miles per hour. Lots of knots = good; no knots = bad.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Beat Up/Wire/Beat the Sh*t Out Of")]), _vm._v(" – To fly extremely low, normally resulting in a Bollocking.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bollocking")]), _vm._v(" – A severe telling off, normally in Number One Uniform and hat on; coffee is rarely offered by the senior officer delivering the bollocking. Punishments range from ‘Now get out of here’, to doing additional Orderly Officer duties, and occasionally posting off the squadron.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Happy Hour")]), _vm._v(" – A tradition of the Service, at which at precisely 1700 on Friday, drinks are served at half price; the end time is less precise. Very popular with Scottish and Yorkshire aircrew.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_vm._v("Ranks in the RAF:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" OR: Other Ranks; all who are below WO/SNCO rank.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" SNCO: Senior Non-Commissioned Officer: sergeants (Sgt), chief technician (Ch Tech), flight sergeant (Flt Sgt).")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" WO: Warrant officer; promoted ex-SNCOs who run the RAF; normally in their late 40s/50s and have ‘seen it all before, Sir’. Can be very frightening, especially to junior officers.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" Commissioned Officers: Everything from pilot officer (PO) to air chief marshal (ACM). Ranks normally abbreviated, so:")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" Fg Off – flying officer")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" Flt Lt – flight lieutenant")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" Sqn Ldr – squadron leader")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" Wg Cdr (not Wingco!) – wing commander")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" Gp Capt – group captain")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" Air Cdre – air commodore")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" AVM – air vice-marshal")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" AM – air marshal")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Squadron Engineering Officer (SEngO)")]), _vm._v(" – Overworked officer, normally the fall guy when flying task not achieved.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("JEngO")]), _vm._v(" – see above. Junior Engineering officer, to whom blame for not achieving flying task is delegated.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Afterburner/Burner/Reheat")]), _vm._v(" – The afterburner, which is a long extension at the back of the engine, combines much of the remaining oxygen from the compressor with jet fuel, squirted into the high-speed exhaust stream from the engine’s turbine, and ignites the mixture. The resulting ‘blowtorch’ shoots through a nozzle at the back of the engine, providing a hard kick of extra thrust, but at the expense of a lot of fuel.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gash Shag")]), _vm._v(" – Junior Officer aircrew with no supervisory responsibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Limo, or wheels")]), _vm._v(" – A car, or something resembling one. Not to be confused with:")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wheel/Exec")]), _vm._v(" – Squadron executive.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Minimum height/minimum separation distance")]), _vm._v(" – The height at which pilots say they never went below.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bullshit")]), _vm._v(" – Hyperbole, exaggeration, lies; extremely common in fighter aircrew.")]), _vm._v(" "), _c('p', {
    staticClass: "gloss"
  }, [_vm._v("Some other abbreviations:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" No 43(F) Sqn; Number 43 (Fighter) Squadron;")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" AOC – Air officer commanding, normally of a Group (Gp), for example 11(F) Gp. Usually an AVM.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" CinC – Commander-in-Chief, of a Command, comprising several Gps. Normally an AM or ACM.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bu"
  }, [_vm._v("•")]), _vm._v(" ‘Stars’ – Air Rank Officers, and RN/Army equivalents, are designated as 1–4 Star.")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" 1-star Air Cdre.")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" 2-star AVM")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" 3-star AM")]), _vm._v(" "), _c('p', {
    staticClass: "cir"
  }, [_c('span', {
    staticClass: "cir"
  }, [_vm._v("○")]), _vm._v(" 4-star ACM"), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a84f217","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Glossary.vue
// module id = 69
// module chunks = 0